import { render, staticRenderFns } from "./items_grid.vue?vue&type=template&id=d79d69b2"
import script from "./items_grid.vue?vue&type=script&lang=js"
export * from "./items_grid.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {ItemsHeader: require('/home/ubuntu/containers/hermes_eshop/components/core/itemsHeader.vue').default,FilterPanel: require('/home/ubuntu/containers/hermes_eshop/components/core/filterPanel.vue').default,Product: require('/home/ubuntu/containers/hermes_eshop/components/core/product.vue').default,ItemsPagination: require('/home/ubuntu/containers/hermes_eshop/components/core/itemsPagination.vue').default})
